import { tracking } from "@/config/business";

/**
 * ============================================================
 *  TRACKING ARCHITECTURE (GA4 / GTM / Google Ads)
 * ============================================================
 *  Semua event konversi dikirim lewat fungsi trackEvent().
 *  ID tracking dikonfigurasi via environment variables (lihat README),
 *  sehingga bisa ditambahkan nanti TANPA mengubah kode website.
 *
 *  Event standar:
 *    - whatsapp_click
 *    - lead_form_start
 *    - lead_form_submit
 *    - phone_click
 *    - request_quote
 *    - survey_request
 * ============================================================
 */

// Cegah event ganda untuk event "sekali saja" (mis. lead_form_start)
const firedOnce = new Set();

export function trackEvent(eventName, params = {}, { once = false } = {}) {
  if (once) {
    if (firedOnce.has(eventName)) return;
    firedOnce.add(eventName);
  }

  const payload = { event: eventName, ...params };

  // Google Tag Manager dataLayer
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // GA4 / gtag langsung (jika gtag tersedia)
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  }

  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.log("[track]", eventName, params);
  }
}

/**
 * Google Ads conversion — dipanggil pada konversi utama (lead submit).
 * Hanya aktif jika Conversion ID & Label dikonfigurasi.
 */
export function trackGoogleAdsConversion() {
  if (
    typeof window !== "undefined" &&
    typeof window.gtag === "function" &&
    tracking.googleAdsConversionId &&
    tracking.googleAdsConversionLabel
  ) {
    window.gtag("event", "conversion", {
      send_to: `${tracking.googleAdsConversionId}/${tracking.googleAdsConversionLabel}`,
    });
  }
}

export const EVENTS = {
  WHATSAPP_CLICK: "whatsapp_click",
  LEAD_FORM_START: "lead_form_start",
  LEAD_FORM_SUBMIT: "lead_form_submit",
  PHONE_CLICK: "phone_click",
  REQUEST_QUOTE: "request_quote",
  SURVEY_REQUEST: "survey_request",
  BOOKING_SERVICE: "booking_service",
  REQUEST_MAINTENANCE_CONTRACT: "request_maintenance_contract",
  REQUEST_HVAC_ASSESSMENT: "request_hvac_assessment",
  REQUEST_AC_ASSESSMENT: "request_ac_assessment",
};

export default trackEvent;
